module.exports = __webpack_public_path__ + "img/Home, Kitchen & Office.6e6f7609.png";